import React from "react";
import { type Moment } from "moment";
import { CprCalendar } from "../../../custom-elements/cps-datepicker/cps-calendar.component";
import type { LegacyEvent } from "../cp-table-header-menu.types";

type DateFilterProps = {
  applyFilter: (event: LegacyEvent<Date | null>) => void;
  selectedDate?: string | Date | Moment;
};

const DateFilter = ({ applyFilter, selectedDate }: DateFilterProps) => {
  return (
    <div>
      <li className="cps-divider cps-margin-left-16 cps-margin-right-16 cps-margin-top-4 cps-margin-bottom-4" />
      <CprCalendar date={selectedDate} events={{ datechange: applyFilter }} />
    </div>
  );
};

export default DateFilter;
